export const DEFAULT_WEBSITES_DELIMITER = ",";
export const FAVICONS_CACHE_TIME = 30 * 60 * 1000; // 30 mins
